<template>
	<div
		class="group flex items-center justify-center gap-2 rounded-full border px-4 py-2 align-middle transition-colors duration-300"
		:class="
			isDisabled
				? 'cursor-default border-gray-500'
				: 'cursor-pointer border-gray-500 hover:border-blue-400'
		"
		@click="onClick"
	>
		<p
			class="text-sm transition-colors duration-300"
			:class="isDisabled ? '' : 'group-hover:text-blue-400'"
		>
			<slot>Remove Me</slot>
		</p>
		<IconTimes
			class="m-auto h-auto w-3 transition-colors duration-300"
			:class="isDisabled ? '' : 'group-hover:text-blue-400'"
		/>
	</div>
</template>

<script setup>
import IconTimes from '@/assets/svg/common/ico-times.svg'

defineProps({
	isDisabled: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const emit = defineEmits(['click'])

const onClick = () => {
	emit('click')
}
</script>
